import { TranslateFn } from "../config";
import { isCommonWord } from "../utils";
import { BaseValidator } from "./BaseValidator";

export type CommonWordsTypes = {
    word: string[],
    commonWords: string[]
}

export class CommonWordsValidator extends BaseValidator {
    private readonly commonWords: string[];

    constructor(message: string | undefined, translate: TranslateFn, data: CommonWordsTypes) {
        super(message ?? translate("is_common_word"))
        this.commonWords = data.commonWords
    }

    validate(value: string): boolean {
        if (!value) return true;
        const MIN_WORD_DISTANCE = 3;
        const hasError = isCommonWord(value, this.commonWords, MIN_WORD_DISTANCE)
        return !hasError
    }
}